// extracted by mini-css-extract-plugin
export const root = "project-preview-grid-module--root--3Ramz";
export const headline = "project-preview-grid-module--headline--A9M9Q";
export const grid = "project-preview-grid-module--grid--DUw9Z";
export const browseMoreNav = "project-preview-grid-module--browseMoreNav--1EARz typography-module--small--2jpCI";